import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import ReducedSkeletonThumbnail from './subcomponents/ReducedSkeletonThumbnail';
import { SkeletonBlock, SkeletonWrapper } from './subcomponents/Skeleton';
import { REDUCED_CARD_THUMBNAIL_SIZES } from './subcomponents/ReducedCardTypes';
import ACSkeletonBox from 'academy-common-lib/components/loading/ACSkeletonBox';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ReducedCardSkeleton = ({
  size = 'small',
  use
}) => {
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    backgroundColor: "fill-surface-default",
    borderColor: "border-container-default",
    borderRadius: "300",
    borderStyle: "solid",
    borderWidth: "100",
    boxShadow: "100",
    "data-test-id": "reduced-card-skeleton",
    inlineSize: "100%",
    paddingBlock: "600",
    paddingInlineEnd: "600",
    paddingInlineStart: "600",
    children: [/*#__PURE__*/_jsx(SkeletonWrapper, {
      borderRadius: "100",
      height: `${REDUCED_CARD_THUMBNAIL_SIZES[size]}px`,
      shimmerColor: use === 'on-dark' ? 'fill-accent-neutral-pressed' : undefined,
      children: /*#__PURE__*/_jsx(ReducedSkeletonThumbnail, {
        backgroundColor: use === 'on-dark' ? 'fill-accent-neutral-pressed' : undefined,
        size: size
      })
    }), /*#__PURE__*/_jsxs(View, {
      flex: 1,
      inlineSize: "96px",
      marginInlineStart: "400",
      children: [/*#__PURE__*/_jsx(SkeletonWrapper, {
        children: /*#__PURE__*/_jsx(ACSkeletonBox, {
          animated: true,
          style: {
            width: '230px',
            height: '16px'
          }
        })
      }), /*#__PURE__*/_jsx(View, {
        marginBlockStart: "300",
        children: /*#__PURE__*/_jsx(SkeletonWrapper, {
          shimmerColor: use === 'on-dark' ? 'fill-accent-neutral-pressed' : undefined,
          children: /*#__PURE__*/_jsx(SkeletonBlock, {
            color: use === 'on-dark' ? 'fill-accent-neutral-pressed' : undefined,
            height: "14px",
            width: "100px"
          })
        })
      })]
    })]
  });
};
export default ReducedCardSkeleton;